import React from 'react';
import { motion } from 'framer-motion';
import { PackageX, DollarSign, AlertTriangle, Wrench } from 'lucide-react';
const pains = [{
  icon: PackageX,
  title: 'El Mueble de Cartón',
  text: 'Estás harto de los muebles de melamina barata que se hinchan con la humedad de Uruguay y no tienen personalidad.'
}, {
  icon: DollarSign,
  title: 'El Costo Prohibitivo',
  text: 'Viste una mesa de río en una tienda de diseño de Punta del Este o Carrasco por u$s 1.500 y sabés que no podés (o no querés) pagarlo.'
}, {
  icon: AlertTriangle,
  title: 'El Miedo al Desperdicio',
  text: 'Compraste un litro de resina, se te llenó de burbujas, no curó o se te filtró toda por el molde. Sentís que tiraste la plata.'
}, {
  icon: Wrench,
  title: 'La Falta de Herramientas',
  text: 'Pensás que necesitás un taller de carpintería profesional con máquinas de miles de dólares para lograr ese acabado espejo.'
}];
export function PainPoints() {
  return <section className="py-8 sm:py-14 bg-[#111827] relative overflow-hidden" data-id="element-82">
      {/* Texture overlay */}
      <div className="absolute inset-0 opacity-5 bg-[radial-gradient(#ffffff_1px,transparent_1px)] [background-size:16px_16px]" data-id="element-83" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-84">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-6 sm:mb-10" data-id="element-85">
          <h2 className="text-2xl md:text-4xl font-bold text-white mb-3 sm:mb-4" data-id="element-86">
            Estás cansado de esto, ¿no?
          </h2>
          <div className="w-24 h-1 bg-[#d4a853] mx-auto rounded-full" data-id="element-87" />
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-8" data-id="element-88">
          {pains.map((pain, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-[#0a0e17] border border-[#ffffff]/5 p-5 sm:p-8 rounded-xl hover:border-[#d4a853]/30 transition-colors group relative overflow-hidden" data-id="element-89">
              <div className="absolute top-0 right-0 p-4 opacity-10 group-hover:opacity-20 transition-opacity" data-id="element-90">
                <pain.icon className="w-24 h-24 text-[#d4a853]" data-id="element-91" />
              </div>

              <div className="relative z-10" data-id="element-92">
                <div className="w-12 sm:w-14 h-12 sm:h-14 bg-[#1e6bb8]/10 rounded-lg flex items-center justify-center mb-4 sm:mb-6 group-hover:bg-[#1e6bb8]/20 transition-colors" data-id="element-93">
                  <pain.icon className="w-6 h-6 sm:w-7 sm:h-7 text-[#d4a853]" data-id="element-94" />
                </div>

                <h3 className="text-lg sm:text-xl font-bold text-white mb-2 sm:mb-4 group-hover:text-[#d4a853] transition-colors" data-id="element-95">
                  {pain.title}
                </h3>

                <p className="text-[#9ca3af] leading-relaxed text-sm" data-id="element-96">
                  {pain.text}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}